import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import DashBoardLayerOne from "../../components/DashBoardLayerOne";
import CategoriesTable from "../../components/CategoryManagement/CategoriesTable";
import SubCategoriesTable from "../../components/CategoryManagement/SubCategoriesTable";
import AddNewCategory from "../../components/CategoryManagement/AddNewCategory";
import AddNewSubCategory from "../../components/CategoryManagement/AddNewSubCategory";


const AddNewSubCategoryPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title="Add Sub Category" subtitle={"Sub Categories"} subUrl={"sub-categories"} />

                <AddNewSubCategory />
                {/* DashBoardLayerOne */}
                {/* <DashBoardLayerOne /> */}

            </MasterLayout>
        </>
    );
};

export default AddNewSubCategoryPage;
